export default __webpack_public_path__ + "static/media/woman.a9f4a26a.png";